import React from "react";
import { Card, Col } from "reactstrap";

import FigureRow from "./Figures";
import { ActivityReportData } from "./types";

/**
 * The period's headline figures, said once, in one quiet row. These used to
 * appear twice (here and again above the usage chart), each with a decorative
 * icon and a counting animation; the numbers are the content.
 */
const SummaryTiles = ({
  data,
  comparable,
  loading,
}: {
  data: ActivityReportData | null;
  comparable: boolean;
  loading: boolean;
}) => {
  const current = data?.summary?.current;
  const change = data?.summary?.change;

  return (
    <Col xs={12}>
      <Card className="activity-report__figures">
        <FigureRow
          comparable={comparable}
          loading={loading}
          figures={[
            {
              label: "Page visits",
              value: current?.visits || 0,
              change: change?.visits,
            },
            {
              label: "Active users",
              value: current?.activeUsers || 0,
              change: change?.activeUsers,
            },
            {
              label: "Visits per user",
              value: current?.visitsPerUser || 0,
              decimals: 1,
              change: change?.visitsPerUser,
            },
            {
              label: "Active agencies",
              value: current?.activeAgencies || 0,
              change: change?.activeAgencies,
            },
            {
              label: "Different pages",
              value: current?.pagesVisited || 0,
              change: change?.pagesVisited,
            },
          ]}
        />
      </Card>
    </Col>
  );
};

export default SummaryTiles;
